import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { usePageStyles } from "../common/pageStyles";
import FileUpload from "./FileUpload";
import AgregateData from "./AgregateData";

const useStyles = makeStyles((theme) => ({
  panels: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2.5),
    alignItems: "flex-start",
  },
  panel: {
    flex: "1 1 420px",
    minWidth: 0,
    padding: theme.spacing(3),
    textAlign: "center",
    boxSizing: "border-box",
  },
}));

// Menu boczne i powiadomienia zapewnia ShellLayout.
const Traces = () => {
  const page = usePageStyles();
  const classes = useStyles();

  return (
    <div>
      <div className={page.pageHeader}>
        <div>
          <h1 className={page.title}>Traces</h1>
          <div className={page.subtitle}>Wgrywanie plików i agregacja danych</div>
        </div>
      </div>

      <div className={classes.panels}>
        <div className={`${page.card} ${classes.panel}`}>
          <FileUpload />
        </div>
        <div className={`${page.card} ${classes.panel}`}>
          <AgregateData />
        </div>
      </div>
    </div>
  );
};

export default Traces;
